export default __webpack_public_path__ + "static/media/gallery-2.67841b9b.jpeg";